// extracted by mini-css-extract-plugin
export default {"withError":"withError_withError__4tabU"};